// 任务类型
export const FIRST_VISIT = '1'
export const RESURVEY = '2'
export const MOTION = '3'
export const NEW_MOTION = '16'
export const OTHER_INVEST = '15'

// 险种
export const CAR_INSURANCE = '01'
export const LIABILITY_INSURANCE = '02'
export const ACCIDENT_INSURANCE = '03'
export const HEALTH_INSURANCE = '04'

// 订单类型
export const QUAN_LIU_CHEN = '2'
export const DAN_DIAN = '1'

// 回访类型
export const SHOU_HOU = '1'
export const WEI_JUE = '2'

// 回访状态
export const REVISIT_BEFORE = '10' // 未开始
export const REVISIT_ING = '20' // 回访中
export const REVISIT_FINISH = '30' // 已完成

// 未决回访完成状态
export const REVISIT_TRACK_SUC = '30' // 回访成功
export const REVISIT_TRACK_FAIL = '40' // 回访失败
